// extracted by mini-css-extract-plugin
export default {"container":"Droplist_container__zAtte","item":"Droplist_item__OccxI"};